import 'core-js/shim';
import 'regenerator-runtime/runtime';
import 'unfetch/polyfill';
import 'array-flat-polyfill';
import moment from 'moment';
// @ts-ignore
import 'moment/locale/fr';
import NProgress from 'nprogress';
import ReactDOM from 'react-dom';
import UniversalRouter from 'universal-router';
import $ from 'jquery';
import { initGraphql } from './core/Apollo';
import { addEventListener, removeEventListener } from './core/DOMUtils';
import history from './core/history';
import getRoutes from './routes';
import './core/FileSystempickerPolyfill';
import './index.css';

moment.locale('fr');
window.$ = $;

if (import.meta.env.DEV) {
  // Disable missing translation message as translations will be added later.
  // We can add a toggle for this later when we have most translations.

  // eslint-disable-next-line
  const consoleError = console.error.bind(console);
  // eslint-disable-next-line
  console.error = (message, ...args) => {
    if (
      typeof message === 'string' &&
      (message.startsWith('[React Intl] Missing message:') ||
        message.startsWith(
          '[CKEDITOR] Error code: cloudservices-no-token-url',
        ) ||
        message.startsWith('[CKEDITOR] For more information about this error'))
    ) {
      return;
    }
    consoleError(message, ...args);
  };
}

const context = {
  setTitle: (value) => (document.title = value),
  setMeta: (name, content) => {
    // Remove and create a new <meta /> tag in order to make it work
    // with bookmarks in Safari
    const elements = document.getElementsByTagName('meta');
    Array.from(elements).forEach((element) => {
      if (element.getAttribute('name') === name) {
        element.parentNode.removeChild(element);
      }
    });
    const meta = document.createElement('meta');
    meta.setAttribute('name', name);
    meta.setAttribute('content', content);
    document.getElementsByTagName('head')[0].appendChild(meta);
  },
};

const resolveRoute = (apolloClient) => {
  const container = document.getElementById('app');
  const currentLocation = history.location;
  const router = new UniversalRouter(getRoutes(apolloClient), {
    context,
  });

  router
    .resolve(currentLocation.pathname)
    .then((html) => {
      ReactDOM.render(html, container);
    })
    .catch((err) => console.error(err));
};

function run(apolloClient) {
  // Re-render the app when window.location changes
  function onLocationChange() {
    // Save the page scroll position into the current location's state
    NProgress.start();
    resolveRoute(apolloClient);
    NProgress.done();
  }

  // Add History API listener and trigger initial change
  const removeHistoryListener = history.listen(onLocationChange);

  resolveRoute(apolloClient);

  // https://developers.google.com/web/updates/2015/09/history-api-scroll-restoration
  let originalScrollRestoration;
  if (window.history && 'scrollRestoration' in window.history) {
    originalScrollRestoration = window.history.scrollRestoration;
    window.history.scrollRestoration = 'manual';
  }

  // Prevent listeners collisions during history navigation
  addEventListener(window, 'pagehide', function onPageHide() {
    removeEventListener(window, 'pagehide', onPageHide);
    removeHistoryListener();
    if (originalScrollRestoration) {
      window.history.scrollRestoration = originalScrollRestoration;
      originalScrollRestoration = undefined;
    }
  });
}

const processApp = async () => {
  const res = await fetch('/config');
  window.__APP_CONFIG__ = await res.json();
  const apolloClient = await initGraphql();
  run(apolloClient);
};

// Run the application when both DOM is ready and page content is loaded
if (
  ['complete', 'loaded', 'interactive'].includes(document.readyState) &&
  document.body
) {
  processApp();
} else {
  document.addEventListener('DOMContentLoaded', processApp, false);
}
